import "./ContactCard.css";

const ContactCard = (props) => {
  const imageContent = (
    <div className="col-8 col-md-10 col-lg-8">
      <img src={props.image} alt="Logo2" className="p-3 circular-image" />
    </div>
  );

  return (
    <div className="contact-card p-3 d-flex flex-column align-items-center">
      {/* pro stranku zamestnanci skryt obrazek */}
      {typeof props.image === "string" &&
      props.image.trim() !== "" &&
      !props.image.trim().toLowerCase().includes("undefined")
        ? imageContent
        : null}
      <h3>
        {props.prefix} {props.firstName} {props.lastName} {props.suffix}
      </h3>
      <div className="text-center">
        <i>
          {props.departments &&
            props.departments.map((department) => (
              <div key={department.documentId}>
                <i>{department.name}</i>
                <br />
              </div>
            ))}
        </i>
      </div>
      <div className="row w-100 m-2 d-flex align-items-center">
        <div className="col-2 ps-1">
          <img
            src="../images/briefcase.svg"
            alt="pozice"
            className="contact-icon"
          />
        </div>
        <div className="col-10 left-border">
          <div>Pozice </div>
          <div>
            <b>{props.position}</b>
          </div>
        </div>
      </div>
      {props.phone && (
        <div className="row w-100 m-2 d-flex align-items-center">
          <div className="col-2 ps-1">
            <img
              src="../images/phone.svg"
              alt="Telefon"
              className="contact-icon"
            />
          </div>
          <div className="col-10 left-border">
            <div>Telefon </div>
            <div>
              <b>{props.phone}</b>
            </div>
            {props?.second_phone && (
              <div>
                <b>{props.second_phone}</b>
              </div>
            )}
          </div>
        </div>
      )}
      {props.email && (
        <div className="row w-100 m-2 d-flex align-items-center">
          <div className="col-2 ps-1">
            <img src="../images/mail.svg" alt="Mail" className="contact-icon" />
          </div>
          <div className="col-10 left-border">
            <div>Email </div>
            <div className="contact-email">
              <b>{props.email}</b>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default ContactCard;
